import { TicketID } from "utils/mongo/tickets.model";
import { ReactNode } from "react";

export interface TicketNoteProps {
  ticketId: TicketID;
  note: ReactNode;
}

export const returnTicketNotes = (t: any): TicketNoteProps[] => [
  {
    ticketId: TicketID.FULL,
    note: <p className="text-1xl text-neutral-300 "></p>,
  },
  {
    ticketId: TicketID.CORPORATE,
    note: (
      <>
        <p className="text-1xl text-neutral-300">
          You will need a unique redemption code to claim this membership tier.
        </p>
      </>
    ),
  },

  {
    ticketId: TicketID.FOUNDING,
    note: (
      <>
        <p className="text-1xl text-neutral-300">
          You will need a unique redemption code to claim this membership tier.
        </p>
      </>
    ),
  },
];
